export default "__VITE_ASSET__BN$jEGus__"